import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import deferRender from 'defer-render-hoc';

import {
  __getGroupedByDate,
  getNextPageLink,
  getIsJourneysLoading,
  getIsJourneysError,
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
  getIsNextPageLoading,
} from 'redux/modules/journeys/selectors';

import { getFinishedFilters } from 'redux/modules/jobs/selectors';

import { journeyCardEnhancer } from 'modules/journey/card/hoc';

import { withRouter } from 'react-router-dom';

import Finished from './component';

const selectors = {
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
  getFilters: getFinishedFilters,
};

const enhance = compose(
  injectIntl,
  deferRender,
  withRouter,
  journeyCardEnhancer(selectors),
  connect((state) => {
    const filters = getFinishedFilters(state);
    const nextPage = getNextPageLink(state);
    return {
      filters,
      loading: getIsJourneysLoading(state),
      hasError: getIsJourneysError(state),
      grouped: __getGroupedByDate(state, filters),
      nextPage,
      nextPageLoading: getIsNextPageLoading(state),
    };
  })
);

export default enhance(Finished);
